import isServer from '@hydra/utils/isServer';

export function sendEvent (event, eventLabel = {}) {
  if (!isServer()) {
    window.dataLayer && window.dataLayer.push({ event, eventLabel });
  }
}
